import {
    ICurrencyMutationsMock, IModalMutationsMock,
    IMutationsMock, IRequestMutationsMock
} from './index'

export const mockCurrencyMutations = (): ICurrencyMutationsMock => ({
    fetchCurrencies: jest.fn(),
    setCurrency: jest.fn()
})

export const mockModalMutations = (): IModalMutationsMock => ({
    setModal: jest.fn()
})

export const mockRequestMutations = (): IRequestMutationsMock => ({
    setOrder: jest.fn()
})

export const mockMutations = (): IMutationsMock => ({
    ...mockCurrencyMutations(),
    ...mockModalMutations(),
    ...mockRequestMutations(),
    setPlatformInfo: jest.fn(),
    setLoading: jest.fn(),
    setTheming: jest.fn(),
    setTheme: jest.fn(),
    setTravel: jest.fn(),
    setFilters: jest.fn()
})
